import React, { ElementType, PropsWithChildren } from 'react'

import { bemJoin, classNames } from '@app/lib/bem'
import { PolymorphicComponentProps } from '@app/lib/types'

import './Heading.scss'

export type HeadingProps<T extends ElementType> = PolymorphicComponentProps<
  T,
  {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
    color?: 'primary' | 'secondary' | 'neutral'
  }
>

const b = bemJoin('lawyer-heading')

export const Heading = <T extends ElementType>({
  size = 'md',
  color = 'neutral',
  as,
  children,
  className,
  ...props
}: PropsWithChildren<HeadingProps<T>>) => {
  const Component = as || 'div'

  return (
    <Component className={classNames(b({ [size]: true, [color]: true }), className)} {...props}>
      {children}
    </Component>
  )
}
